var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 378 378",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-18.5756,-64.4671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371,93.7L26.6,228C15.4,232.3 16.1,248.4 27.6,251.7L115.1,277.5L147.8,381.1C151.2,391.9 164.9,395.2 172.9,387.1L218.1,340.9L306.9,406.1C317.8,414.1 333.2,408.2 336,395L394.8,113.9C397.6,100.1 384.1,88.6 371,93.7ZM327.8,156.1L167.8,297.6C166.2,299 165.2,301 165,303.1L158.8,357.9C158.6,359.7 156.1,359.9 155.6,358.2L130.3,276.5C129.1,272.8 130.7,268.7 134,266.6L322.9,149.4C327.2,146.8 331.6,152.8 327.8,156.1Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.a993ce60.svg";
export { ForwardRef as ReactComponent };